import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Compact page header: Dashboard breadcrumb + optional trail + single-line title.
 * @param {string} title
 * @param {string} [icon] - Font Awesome class e.g. "fa-users"
 * @param {{ label: string, to?: string }[]} [trail] - crumbs after Dashboard
 * @param {React.ReactNode} [actions] - right-side buttons
 * @param {boolean} [hideBreadcrumb] - e.g. Dashboard root page
 */
function BreadcrumbTrail({ trail, hideBreadcrumb }) {
  if (hideBreadcrumb) return null;
  return (
    <div className="page-breadcrumb">
      <Link to="/dashboard">
        <i className="fas fa-gauge-high" style={{ fontSize: 10 }} /> Dashboard
      </Link>
      {trail.map((item, i) => (
        <React.Fragment key={`${item.label}-${i}`}>
          <i className="fas fa-chevron-right" style={{ fontSize: 9 }} />
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            <span className="page-breadcrumb-current">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default function PageHeader({
  title,
  subtitle,
  icon,
  trail = [],
  actions,
  hideBreadcrumb = false,
  inline = false,
}) {
  if (inline) {
    const showTitleBlock = Boolean(title || subtitle || icon);
    return (
      <div className="admin-page-header-inline fade-up">
        <BreadcrumbTrail trail={trail} hideBreadcrumb={hideBreadcrumb} />
        {(showTitleBlock || actions) ? (
          <div className="admin-page-header-inline-end">
            {showTitleBlock ? (
              <div className="admin-page-header-title-block">
                {icon ? (
                  <i className={`fas ${icon} admin-page-header-inline-icon`} aria-hidden />
                ) : null}
                <div className="admin-page-header-title-text">
                  {title ? (
                    <span className="admin-page-header-inline-title">{title}</span>
                  ) : null}
                  {subtitle ? (
                    <span className="admin-page-header-inline-sub">{subtitle}</span>
                  ) : null}
                </div>
              </div>
            ) : null}
            {actions ? <div className="admin-page-header-actions">{actions}</div> : null}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="admin-page-header-compact fade-up">
      <BreadcrumbTrail trail={trail} hideBreadcrumb={hideBreadcrumb} />
      <div className="admin-page-header-row">
        <div>
          <h1>
            {icon ? (
              <i className={`fas ${icon}`} style={{ color: 'var(--orange)', fontSize: 16, marginRight: 8 }} />
            ) : null}
            {title}
          </h1>
          {subtitle ? (
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748B', fontWeight: 500 }}>{subtitle}</p>
          ) : null}
        </div>
        {actions ? <div className="admin-page-header-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
